export const DRAWER_WIDTH = 350;
